const { document } = global;

const IMG_SELECTOR = 'img.lazy';

const loadImage = lazyImage => {
    lazyImage.src = lazyImage.dataset.src;
    lazyImage.srcset = lazyImage.dataset.srcset;
    lazyImage.classList.remove("lazy");
};

document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = [].slice.call(document.querySelectorAll(IMG_SELECTOR));

    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    loadImage(lazyImage);
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        }, {rootMargin: '0px 0px 200px 0px'});

        lazyImages.forEach(lazyImage => {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        lazyImages.forEach(lazyImage => {
            loadImage(lazyImage);
        });
    }
});